import { PropsWithChildren } from 'react'
import { useAuth } from '../contexts/Auth'
import { HypertuneProvider } from '../generated/hypertune.react'
import { getUserAnonymousID } from '../helpers/UserLocalStorageHelper'

export default function AppHypertuneProvider({ children }: PropsWithChildren) {
  const { currentUser } = useAuth()
  const env = process.env.REACT_APP_ENVIRONMENT
  const token = process.env.REACT_APP_HYPERTUNE_TOKEN

  if (!token || env == 'dev') return children

  return (
    <HypertuneProvider
      createSourceOptions={{
        token: token,
        remoteLogging: {
          mode: process.env.REACT_APP_ENVIRONMENT === 'dev' ? 'off' : 'session',
        },
      }}
      rootArgs={{
        context: {
          environment:
            process.env.REACT_APP_ENVIRONMENT === 'production'
              ? 'production'
              : 'development',
          user: {
            id: currentUser?.id.toString() ?? '',
            anonymousID: getUserAnonymousID(),
            name: currentUser?.name ?? '',
            email: currentUser?.email ?? '',
          },
        },
      }}
    >
      {children}
    </HypertuneProvider>
  )
}
